// Import model
import { ImageFieldOptions } from '../models/ImageFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ImageFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class ImageFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a ImageFieldOptions instance
   */
  static deserialize(json: string): ImageFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ImageFieldOptions instance
   */
  static fromObject(obj: any): ImageFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ImageFieldOptions');
    }


    const instance: ImageFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      _9B1E2543: obj['_9b1e2543'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ImageFieldOptions instances
   */
  static deserializeArray(json: string): ImageFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ImageFieldOptions instance to a JSON string
   */
  static serialize(instance: ImageFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ImageFieldOptions instance to a plain object
   */
  static toObject(instance: ImageFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      '_9b1e2543': instance._9B1E2543,
    };
  }

  /**
   * Serializes an array of ImageFieldOptions instances to a JSON string
   */
  static serializeArray(instances: ImageFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
